import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Authorization } from "../../../Context/Authorization";
import Preloader from "../../../shared/PreLoaders";
import { Container, Table, Form } from "react-bootstrap";

const VFCLoansPage = () => {
  const { vfcId } = useParams();
  const [vfc, setVfc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedLoanType, setSelectedLoanType] = useState("department"); // default

  const navigate = useNavigate();
  const Api = process.env.REACT_APP_API;
  const LOCAL_KEY = `vfcLoanSummarryData${vfcId}`;

  const saveToLocalCache = (vfcData) => {
    localStorage.setItem(
      LOCAL_KEY,
      JSON.stringify({ vfcList: vfcData, timestamp: new Date().toISOString() })
    );
  };

  const loadFromLocalCache = () => {
    const cached = localStorage.getItem(LOCAL_KEY);
    return cached ? JSON.parse(cached) : null;
  };

  const fetchVFCDetails = async () => {
    const config = Authorization();
    try {
      const res = await axios.get(
        `${Api}/api/drill/loan/by-vfc/${vfcId}`,
        config
      );
      setVfc(res.data.data);
      saveToLocalCache(res.data.data);
    } catch (error) {
      console.error("Failed to fetch VFC details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    const cached = loadFromLocalCache();
    if (cached && cached.vfcList) {
      setVfc(cached.vfcList);
      setLoading(false);
    } else {
      fetchVFCDetails();
    }
  }, [vfcId]);

  if (loading) return <Preloader loading={true} />;
  if (!vfc)
    return <p className="text-danger m-5">VFC not found or access denied.</p>;

  // Extract data
  const totalMembers = vfc.totalMembers || {};
  const deptBeneficiaries = vfc.departmentLoanBeneficiaries || {};
  const deptNotTaken = vfc.departmentLoanNotTaken || {};
  const rflBeneficiaries = vfc.revolvingFundLoanBeneficiaries || {};
  const rflNotTaken = vfc.revolvingFundLoanNotTaken || {};

  // Select current data based on checkbox
  const currentData =
    selectedLoanType === "department"
      ? {
          beneficiaries: deptBeneficiaries,
          notTaken: deptNotTaken,
        }
      : {
          beneficiaries: rflBeneficiaries,
          notTaken: rflNotTaken,
        };
  const formatDateTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
  };
  return (
    <div>
      <div className="page-header">
        <h3 className="page-title">{}</h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li
              className="breadcrumb-item"
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => navigate(-1)}
            >
              ← Back
            </li>
            <li
              className="breadcrumb-item active"
              style={{
                color: "red",
                cursor: "pointer",
              }}
              onClick={() => navigate("/dashboard")}
            >
              🏠 Home
            </li>
          </ol>
        </nav>
      </div>
      <div className="d-flex justify-content-between align-items-center mb-3 px-2">
        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={() => {
            localStorage.removeItem(LOCAL_KEY);
            setLoading(true);
            fetchVFCDetails();
          }}
        >
          🔄 Refresh Now
        </button>

        <div className="text-muted small">
          Last Refreshed:
          {loadFromLocalCache()?.timestamp
            ? formatDateTime(loadFromLocalCache().timestamp)
            : "Not Available"}
        </div>
      </div>
      <div className="card bg-gradient-CoolSky card-img-holder text-white">
        <div className="card-body">
          <img
            src={require("../../../../assets/images/dashboard/circle.png")}
            className="card-img-absolute"
            alt="circle"
          />
          <h4 className="font-weight-normal mb-3"> VFC - {vfc.vfcName}</h4>
          <div
            className="d-flex justify-content-center mb-3 "
            style={{ cursor: "pointer" }}
          >
            <Form.Check
              inline
              type="radio"
              label="Department Loan"
              name="loanType"
              value="department"
              checked={selectedLoanType === "department"}
              onChange={(e) => setSelectedLoanType(e.target.value)}
            />
            <Form.Check
              inline
              type="radio"
              label="Revolving Fund Loan"
              name="loanType"
              value="revolving"
              checked={selectedLoanType === "revolving"}
              onChange={(e) => setSelectedLoanType(e.target.value)}
            />
          </div>
        </div>
      </div>

      <Container className="mt-4">
        <Table bordered className="text-center">
          <thead>
            <tr>
              <th colSpan="9">
                {selectedLoanType === "department"
                  ? "Department Loan"
                  : "Revolving Fund Loan"}{" "}
                Summary
              </th>
            </tr>
            <tr>
              <th colSpan="3">Total Members in VFC</th>
              <th colSpan="3">Total Members Availed</th>
              <th colSpan="3">Total Members Not Availed</th>
            </tr>
            <tr>
              <th>Male</th>
              <th>Female</th>
              <th>Third Gender</th>
              <th>Male</th>
              <th>Female</th>
              <th>Third Gender</th>
              <th>Male</th>
              <th>Female</th>
              <th>Third Gender</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{totalMembers.male || 0}</td>
              <td>{totalMembers.female || 0}</td>
              <td>{totalMembers.others || 0}</td>
              <td>{currentData.beneficiaries.male || 0}</td>
              <td>{currentData.beneficiaries.female || 0}</td>
              <td>{currentData.beneficiaries.others || 0}</td>
              <td>{currentData.notTaken.male || 0}</td>
              <td>{currentData.notTaken.female || 0}</td>
              <td>{currentData.notTaken.others || 0}</td>
            </tr>
          </tbody>
        </Table>
      </Container>
    </div>
  );
};

export default VFCLoansPage;
